import * as store from '@/store';
import KuAuthority from '@/auth/KuAuthority';
import {RepositoryScope} from '@/Constant';

import {IRepository, IScope} from '../types';

const ScopeMap = {
    [RepositoryScope.Repository]: IScope.private,
    [RepositoryScope.SpaceReaderLimit]: IScope.limit,
    [RepositoryScope.SpaceReader]: IScope.public,
};

export const repository: IRepository = {
    getRepoBaseInfo: () => {
        const curRepository = store.getData(store.KEYS.CUR_REPOSITORY) || {};

        const {repositoryGuid, repositoryName} = curRepository;

        return {
            repositoryId: repositoryGuid,
            repositoryName,
        };
    },
    getRepoPermission: () => {
        const {isAdmin, isMember, isReader} = KuAuthority.getAuthRepository();
        const curRepository = store.getData(store.KEYS.CUR_REPOSITORY) || {};

        return {
            isAdmin,
            isMember,
            isReader,
            scope: ScopeMap[curRepository.scope] || IScope.private,
        };
    },
};
